import "./style.css";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { gsap } from "gsap"; 
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
//import barba from '@barba/core';
import Lenis from '@studio-freight/lenis';
console.clear();

function start(){
const lenis = new Lenis({
  duration:1.2,
  easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
  direction:"vertical",
  gestureDirection:"vertical",
  smooth:true,
  smoothTouch:false,
  touchMultiplier:2,
});

// lenis.on('scroll', (e) => {
//   console.log(e)
// });

gsap.registerPlugin(ScrollTrigger,TextPlugin, ScrollToPlugin);
lenis.on('scroll', ScrollTrigger.update);


gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
});


gsap.ticker.lagSmoothing(0);

// test scrollto another 

// window.lenis = lenis;

// window.onload = (event) => {
//   let urlHash = window.location.href.split("#")[1];
//   let scrollElem = gsap.utils.toArray("#" + urlHash);
//   if (urlHash && scrollElem) {
//     gsap.to(window, { scrollTo: {y:scrollElem, offsetY:-200}, duration:.6, ease:"power1.inOut" });
//   }
// };
// var buttons = gsap.utils.toArray("buttonScrollTo");
// buttons.forEach(function(elem,i) {
//   elem.addEventListener("click", function() {
//     gsap.to(window, {scrollTo:{y:"#disclaimer" + (i), offsetY:+20}, duration:1, ease: "power2.inOut"});
//   })
// });

// end scrollto another page



//Menu Aminamtion
const ham = document.querySelector('#ham');
const spanTop = document.querySelector('#ham span:nth-of-type(1)');
const spanBottom = document.querySelector('#ham span:nth-of-type(2)');
const fullMenu = document.querySelector('#fullMenu');
const linkMenu = document.querySelectorAll('#listFullMenu li');

var tlMenu = gsap.timeline({paused:true, reversed:true});

tlMenu.add('hamAnimation');
tlMenu.to(spanTop, {duration:.4, rotate:45, top:30, transformOrigin:"center", backgroundColor: "#F5F3ED", ease:"power1.inOut"}, 'hamAnimation');
tlMenu.to(spanBottom, {duration:.4, rotate:-45, top:30, transformOrigin:"center", backgroundColor: "#F5F3ED", ease:"power1.inOut"}, 'hamAnimation');
tlMenu.to(fullMenu, {duration:1, clipPath: 'circle(150% at 100% 0%)', ease:"power1.inOut"}, 'hamAnimation');

function animationFullMenu(){
  tlMenu.reversed() ? tlMenu.play() : tlMenu.reverse();
};
ham.addEventListener('click', animationFullMenu);
linkMenu.forEach( listLink => {
  listLink.addEventListener('click', animationFullMenu);
});
//End Menu Animation

//barba.hooks.enter(() => {
  //window.scrollTo(0,0);
// });
// barba.hooks.beforeLeave(() => {
//     ScrollTrigger.getAll().forEach(t => t.kill(true));
//     ScrollTrigger.refresh(true);
//   });
// barba.hooks.afterEnter(() => {
//     //ScrollTrigger.getAll().forEach(t => t.kill(false));
//     ScrollTrigger.refresh(true);
//   });
// barba.init({
  //debug:true,
  //logLevel:'error',
  // transitions:[
    // {
    //   name:'animations-home',
    //   to:{
    //     namespace:['home']
    //   },
    //   once({next}){
        console.log('entro per la prima volta in home');
        //Animation Hero Section
        const text1 = gsap.utils.toArray('.text1');
        const text2 = gsap.utils.toArray('.text2');
        const fotoHero = document.querySelector('#foto');
        const payoffHero = document.querySelector('#payoff-hero');
        const descriptionHero = document.querySelector('#description-hero');
        const logoLoader = document.querySelector('#logoLoader');
        const loader = document.querySelector('#loader');

        let tlHero = gsap.timeline();

        tlHero.set(loader, {display:"flex"});
        tlHero.add('animationLoader');
        tlHero.to(logoLoader, {duration:.6, rotation:360, repeat:1, yoyo:true, ease:"power1.inOut"},'animationLoader');
        tlHero.to(logoLoader, {duration:.9, autoAlpha:0, ease:"power1.inOut"},'animationLoader');
        tlHero.to(loader, {duration:.4, autoAlpha:0, ease:"power1.inOut"});
        tlHero.from(text1, {yPercent:-45, autoAlpha:0, stagger:.1, ease:"power1.inOut", clearProps:"all"});
        tlHero.addLabel('elisav')
        tlHero.from(text2, {yPercent:45, autoAlpha:0, stagger:.1, ease:"power1.inOut", clearProps:"all"}, 'elisav');
        tlHero.from(fotoHero, {yPercent:45, autoAlpha:0, duration:1.2, ease:"power1.inOut", clearProps:"all"}, 'elisav');
        tlHero.from(payoffHero, {yPercent:-45, autoAlpha:0, duration:.9, ease:"power1.inOut", clearProps:"all"}, 'elisav');
        tlHero.from(descriptionHero, {yPercent:45, autoAlpha:0, duration:.9, ease:"power1.inOut", clearProps:"all"}, 'elisav');
        //End Animation Hero Section
    //   },
    //   leave: ({current}) => {
    //     console.log('sto lasciando home');
    //     return gsap.to(current.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
    //   },
    //   enter({next}){
    //     console.log('sto entranto in home');
    //     gsap.from(next.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
    //   },
    // },
    // {
  //     name:'animations-chi-sono',
  //     to:{
  //       namespace:['chi-sono']
  //     },
  //     once({next}){
  //       console.log('entro per la prima volta in chi-sono')
  //     },
  //     leave: ({current}) => {
  //       console.log('sto lasciando chi-sono')
  //       return gsap.to(current.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
  //     },
  //     enter({next}){
  //       console.log('sto entranto in chi-sono')
  //       gsap.from(next.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
  //     },
  //   },{
  //     name:'animations-cosa-faccio',
  //     to:{
  //       namespace:['cosa-faccio']
  //     },
  //     once({next}){
  //       console.log('entro per la prima volta in cosa-faccio')
  //     },
  //     leave: ({current}) => {
  //       console.log('sto lasciando cosa-faccio');
  //       return gsap.to(current.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
  //     },
  //     enter({next}){
  //       console.log('sto entranto in cosa-faccio');
  //       gsap.from(next.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
  //     },
  //   },{
  //     name:'animations-contatti',
  //     to:{
  //       namespace:['contatti']
  //     },
  //     once({next}){
  //       console.log('entro per la prima volta in contatti');
  //     },
  //     leave: ({current}) => {
  //       console.log('sto lasciando contatti');
  //       return gsap.to(current.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
  //     },
  //     enter({next}){
  //       console.log('sto entranto in contatti');
  //       gsap.from(next.container, {autoAlpha:0, duration:.4, ease:"power1.inOut"});
  //     },
  //   },
  // ],
  // views: [{
    // namespace:'home',
    // beforeEnter(){
      console.log('prima di entrare in home')
      //ScrollTrigger.refresh(true);

      //gsap.set('#loader', {display:"none"});
      
      //var vids = document.querySelectorAll("video"); vids.forEach(vid => { var playPromise = vid.play(); if (playPromise !== undefined) { playPromise.then(_ => {}).catch(error => {}); }; });

      const animbtp = gsap.to("#btp-wtp", {duration:.5, autoAlpha:1, ease:"power1.inOut"});
      ScrollTrigger.create({
        animation: animbtp,
        trigger:"#heroIndex",
        start: "bottom 50%",
        end: "bottom 55%",
        toggleActions: "play none reverse none"
      });
      const swiper0 = new Swiper('.swiper', {
        // Optional parameters
        slidesPerView:1,
        breakpoints:{
          1024:{
            slidesPerView:3,
          },
        },
        direction: 'horizontal',
        loop: true,
        // If we need pagination      
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // And if we need scrollbar
      });
      // const swiper1 = new Swiper('.swiper-2', {
      //   // Optional parameters
      //   slidesPerView:3,
      //   breakpoints:{
      //     1024:{
      //       slidesPerView:3,
      //     },
      //   },
      //   direction: 'horizontal',
      //   loop: true,
      //   // If we need pagination      
      //   // Navigation arrows
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //   },
      //   // And if we need scrollbar
      // });


      // ScrollTrigger.refresh(true);
      

      let counter1 = gsap.from("#counter1", {
        duration: 1, 
        textContent:"0", 
        snap:{textContent:1}
      });
      ScrollTrigger.create({
        animation: counter1,
        trigger: "#counter1",
        start: "top 85%"
      });
      let counter2 = gsap.from("#counter2", {
        duration: 1, 
        textContent:"0", 
        snap:{textContent:1}
      });
      ScrollTrigger.create({
        animation: counter2,
        trigger: "#counter2",
        start: "top 85%"
      });
      let counter3 = gsap.from("#counter3", {
        duration: 1, 
        textContent:"0", 
        snap:{textContent:1}
      });
      ScrollTrigger.create({
        animation: counter3,
        trigger: "#counter3",
        start: "top 85%"
      });

      let tlvideo = gsap.timeline();
      tlvideo.addLabel("firstmove")
      tlvideo.from('#video-text1', {xPercent:50}, 'firstmove');
      tlvideo.from('#video-text3', {xPercent:50}, 'firstmove');
      tlvideo.from('#video-text2', {xPercent:-50}, 'firstmove');
      ScrollTrigger.create({
        animation: tlvideo,
        trigger: "#videoPresentation",
        start: "top 50%",
        end: "top top",
        toggleActions: "play none reverse none",
      });

      const animparalx1 = gsap.fromTo("#img-gallery1", {yPercent:10}, {yPercent:-10});
      ScrollTrigger.create({
        animation: animparalx1,
        trigger:"#img-gallery1",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });
      const animparalx2 = gsap.fromTo("#img-gallery2", {yPercent:15}, {yPercent:-15});
      ScrollTrigger.create({
        animation: animparalx2,
        trigger:"#img-gallery2",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });
      const animparalx3 = gsap.fromTo("#img-gallery3", {yPercent:20}, {yPercent:-20});
      ScrollTrigger.create({
        animation: animparalx3,
        trigger:"#img-gallery3",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });
      const animparalx4 = gsap.fromTo("#img-gallery4", {yPercent:10}, {yPercent:-10});
      ScrollTrigger.create({
        animation: animparalx4,
        trigger:"#img-gallery4",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });



      console.log('tutti gli script sono stati caricati')
    // },

    // beforeLeave(){
    //   console.log('before all the scripts killed')
      //const triggers = ScrollTrigger.getAll();
      //if (triggers) {
    //      triggers.forEach((trigger) => {
    //          trigger.kill();
    //      });
    //  };
  //     gsap.set("#btp-wtp", {autoAlpha:0});
  //     console.log('all the instances were killed')
  // },
  // },{
    // namespace:'cosa-faccio',
    // beforeEnter(){
      //ScrollTrigger.refresh(true);
      const animbtpcosafaccio = gsap.to("#btp-wtp", {duration:.5, autoAlpha:1, ease:"power1.inOut"});
      ScrollTrigger.create({
        animation: animbtpcosafaccio,
        trigger:"#heroCosafaccio",
        start: "bottom 50%",
        end: "bottom 55%",
        toggleActions: "play none reverse none"
      });
      const animparalxchisono = gsap.to("#foto-hero-section", {yPercent:-65});
      ScrollTrigger.create({
        animation: animparalxchisono,
        trigger:"#heroCosafaccio",
        start:"top 20%",
        end: "bottom top",
        scrub: true,
      });
      const animparalx1chisono = gsap.fromTo("#img-gallery1cosaFaccio", {yPercent:10}, {yPercent:-10});
      ScrollTrigger.create({
        animation: animparalx1chisono,
        trigger:"#img-gallery1cosaFaccio",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });
      const animparalx2chisono = gsap.fromTo("#img-gallery2cosaFaccio", {yPercent:15}, {yPercent:-15});
      ScrollTrigger.create({
        animation: animparalx2chisono,
        trigger:"#img-gallery2cosaFaccio",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });
      const animparalx3chisono = gsap.fromTo("#img-gallery3cosaFaccio", {yPercent:20}, {yPercent:-20});
      ScrollTrigger.create({
        animation: animparalx3chisono,
        trigger:"#img-gallery3cosaFaccio",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });
      const animparalx4chisono = gsap.fromTo("#img-gallery4cosaFaccio", {yPercent:25}, {yPercent:-25});
      ScrollTrigger.create({
        animation: animparalx4chisono,
        trigger:"#img-gallery4cosaFaccio",
        start:"top bottom",
        end: "bottom top",
        scrub: true,
      });
      // const swiper2 = new Swiper('.swiper', {
      //   // Optional parameters
      //   direction: 'horizontal',
      //   loop: true,
      //   // If we need pagination      
      //   // Navigation arrows
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //   },
      //   // And if we need scrollbar
      // });
  //   },
  //   beforeLeave(){
  //     console.log('before all the scripts chi sono killed')
  //     // const triggers = ScrollTrigger.getAll();
  //     // if (triggers) {
  //     //     triggers.forEach((trigger) => {
  //     //         trigger.kill();
  //     //     });
  //     // };
  //     gsap.set("#btp-wtp", {autoAlpha:0});
  //     console.log('all the instances were chi sono killed')
  //   },
  // },{
  //   namespace:'chi-sono',
  //   beforeEnter(){
      //ScrollTrigger.refresh(true);
      const animbtpchisono = gsap.to("#btp-wtp", {duration:.5, autoAlpha:1, ease:"power1.inOut"});
      ScrollTrigger.create({
        animation: animbtpchisono,
        trigger:"#heroChisono",
        start: "bottom 50%",
        end: "bottom 55%",
        toggleActions: "play none reverse none"
      });
      
      // const swiper3 = new Swiper('.swiper', {
      //   // Optional parameters
      //   direction: 'horizontal',
      //   loop: true,
      //   // If we need pagination      
      //   // Navigation arrows
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //   },
      //   // And if we need scrollbar
      // });
  //   },
  //   beforeLeave(){
  //     console.log('before all the scripts chi sono killed')
  //     // const triggers = ScrollTrigger.getAll();
  //     // if (triggers) {
  //     //     triggers.forEach((trigger) => {
  //     //         trigger.kill();
  //     //     });
  //     // };
  //     gsap.set("#btp-wtp", {autoAlpha:0});
  //     console.log('all the instances were chi sono killed')
  //   },
  // },{
  //   namespace:'contatti',
  //   beforeEnter(){
      //ScrollTrigger.refresh(true);
      const animbtpcontatti = gsap.to("#btp-wtp", {duration:.5, autoAlpha:1, ease:"power1.inOut"});
      ScrollTrigger.create({
        animation: animbtpcontatti,
        trigger:"#heroContatti",
        start: "bottom 50%",
        end: "bottom 55%",
        toggleActions:"play none reverse none"
      });
      
      const animparalxcontatti = gsap.to("#foto-hero-section", {yPercent:-65});
      ScrollTrigger.create({
        animation: animparalxcontatti,
        trigger:"#heroContatti",
        start:"top 20%",
        end: "bottom top",
        scrub: true,
      });
      // const swiper = new Swiper('.swiper', {
      //   // Optional parameters
      //   direction: 'horizontal',
      //   loop: true,
      //   // If we need pagination      
      //   // Navigation arrows
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //   },
      //   // And if we need scrollbar
      // });
    // },
    // beforeLeave(){
    //   console.log('before all the scripts chi sono killed')
    //   // const triggers = ScrollTrigger.getAll();
    //   // if (triggers) {
    //   //     triggers.forEach((trigger) => {
    //   //         trigger.kill();
    //   //     });
    //   // };
    //   gsap.set("#btp-wtp", {autoAlpha:0});
    //   console.log('all the instances were chi sono killed')
    // },
//   }]
// });
};

// Document ready JS
window.addEventListener("load", (event) => start());